import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OrbBackground from "@/components/OrbBackground";
import CustomCursor from "@/components/CustomCursor";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Lessons from "@/pages/Lessons";
import LessonDetail from "@/pages/LessonDetail";
import Prompts from "@/pages/Prompts";
import PromptDetail from "@/pages/PromptDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Newsletter from "@/pages/Newsletter";
import Workshops from "@/pages/Workshops";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function Shell({ children }) {
  const loc = useLocation();
  const hideChrome = ["/login", "/register", "/forgot-password", "/reset-password"].includes(loc.pathname);
  return (
    <>
      <OrbBackground />
      <CustomCursor />
      {!hideChrome && <Navbar />}
      <div className="relative z-10">
        {children}
        {!hideChrome && <Footer />}
      </div>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0B191E",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "#FFFFFF",
                borderRadius: "14px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
              },
            }}
          />
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lessons" element={<Lessons />} />
              <Route path="/lessons/:slug" element={<LessonDetail />} />
              <Route path="/prompts" element={<Prompts />} />
              <Route path="/prompts/:slug" element={<PromptDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/workshops" element={<Workshops />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Shell>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
